import fetchAx from "@/axios.js";
export default {
  namespaced: true,
  state: {
    platformSettings: [],
    isLoad: true,
    mainPage: null,
    tabs: [],
  },
  mutations: {
    setPlatformSettings(state, payload) {
      state.platformSettings = payload;
    },
    setIsLoad(state, payload) {
      state.isLoad = payload;
    },
    setTabs(state, tabs) {
      state.tabs = tabs;
    },
    setMainPage(state, payload) {
      state.mainPage = payload.find((settings) => {
        return settings.elementKey == "ANASAYFA";
      });
      state.isLoad = false;
    },
  },
  getters: {
    getTabs: (state) => state.tabs,
    getIsLoad: (state) => state.isLoad,
    getPlatformSettingByKey: (state) => (key) => {
      const platformSettings = state.platformSettings.find((settings) => {
        return settings.elementKey == key;
      });
      return platformSettings;
    },
    getMainPage: (state) => {
      return state.mainPage ? state.mainPage.param : null;
    },
  },
  actions: {
    async tabFind({ state }, compKey) {
      return new Promise(async (resolve, reject) => {
        var tabIndex = state.tabs.findIndex(
          (s) => s.tabId.slice(0, -1) == compKey
        );
        resolve(tabIndex);
      });
    },
    async fetchPlatformSettings({ rootState, commit }) {
      let url =
        "v2/Element/GetPlatformElements?platformId=" +
        rootState.checkPlatformStore.platformId;

      //console.log("Geldim", rootState.checkPlatformStore.platformId);
      if (
        rootState.signalRStore.myUser &&
        rootState.signalRStore.myUser.email === "becoca_25@hotmail.com"
      ) {
        url += "&email=becoca_25@hotmail.com";
      }
      await fetchAx
        .get(url)
        .then((response) => {
          commit("setPlatformSettings", response.data);
          commit("setMainPage", response.data);
        })
        .catch((error) => {
          commit("setIsLoad", false);
          console.error("Error fetching data:", error);
        });
    },
  },
};
